import React, { useState, useEffect } from "react";
import { Calendar } from "lucide-react";

const iso = (d) => d.toISOString().slice(0, 10);

const PRESETS = [
  { key: "all", label: "All time" },
  { key: "month", label: "This month" },
  { key: "30d", label: "Last 30 days" },
  { key: "90d", label: "Last 90 days" },
  { key: "year", label: "This year" },
  { key: "custom", label: "Custom" },
];

const computeRange = (key) => {
  const now = new Date();
  if (key === "month") return [`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`, ""];
  if (key === "30d") { const s = new Date(now); s.setDate(s.getDate() - 30); return [iso(s), ""]; }
  if (key === "90d") { const s = new Date(now); s.setDate(s.getDate() - 90); return [iso(s), ""]; }
  if (key === "year") return [`${now.getFullYear()}-01-01`, ""];
  return ["", ""]; // all / custom
};

// Fires onChange(startISODate, endISODate) — empty strings mean "no bound".
export function DateRangeFilter({ onChange, defaultPreset = "all" }) {
  const [preset, setPreset] = useState(defaultPreset);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  useEffect(() => {
    if (defaultPreset && defaultPreset !== "all" && defaultPreset !== "custom") {
      const [s, e] = computeRange(defaultPreset);
      onChange(s, e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const choose = (key) => {
    setPreset(key);
    if (key === "custom") return; // custom → wait for Apply
    const [s, e] = computeRange(key);
    onChange(s, e);
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="date-range-filter">
      <Calendar className="w-4 h-4 text-[#2D6A4F]" />
      {PRESETS.map((p) => (
        <button
          key={p.key}
          type="button"
          data-testid={`range-preset-${p.key}`}
          onClick={() => choose(p.key)}
          className={`rounded-full px-3 py-1.5 text-xs font-medium border transition-colors ${
            preset === p.key
              ? "bg-[#1E3F33] text-white border-[#1E3F33]"
              : "bg-white text-[#1E3F33] border-[#1E3F33]/15 hover:border-[#1E3F33]/40"
          }`}
        >
          {p.label}
        </button>
      ))}
      {preset === "custom" && (
        <div className="flex flex-wrap items-center gap-2 mt-2 sm:mt-0">
          <input
            type="date"
            data-testid="range-custom-start"
            value={start}
            onChange={(e) => setStart(e.target.value)}
            className="rounded-lg border border-[#1E3F33]/15 bg-white px-2.5 py-1.5 text-xs text-[#1E3F33] focus:outline-none focus:border-[#2D6A4F]"
          />
          <span className="text-xs text-[#8A9A86]">to</span>
          <input
            type="date"
            data-testid="range-custom-end"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
            className="rounded-lg border border-[#1E3F33]/15 bg-white px-2.5 py-1.5 text-xs text-[#1E3F33] focus:outline-none focus:border-[#2D6A4F]"
          />
          <button
            type="button"
            data-testid="range-custom-apply"
            onClick={() => onChange(start, end)}
            className="btn-secondary text-xs py-1.5 px-3"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
}
